import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { config } from '../../common';
import { useHistory } from '../../common/RouterHooks';
import Header from '../../main/components/Header';

const ContactConfirm: React.FC<{}> = (containerProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    const close = (e: any) => {
        e.preventDefault();
        history.push(`${config.BaseURL}`);
    };
    return (
        <div className={classNames(['grid-container', 'padding-bottom-4', 'service-inclusive', 'tyres'])}>
            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                <Header title={t(`tyre:header-contact`)} />
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <div className={'margin-top-2'}>
                        <h2>{t(`tyre:contact.confirm.text1`)}</h2>
                    </div>
                    <p className={'margin-top-15'}>{t('tyre:contact.confirm.text2')}</p>
                    <p>{t('tyre:contact.confirm.text3')}</p>
                    <div className={'margin-top-2'}>
                        <button className={classNames(['button', 'bttSubscrever'])} onClick={(e) => close(e)}>{t('surveyfollowup:surveyfollowupConfirm.closeBtn')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactConfirm;
